import Client from "../client/Short"
const resource = "/api/v2/publish"

const getRandomShort = (params) => {
  return Client.get(`${resource}/short-video/random/`, { params })
}
const getShortById = (params) => {
  return Client.get(`${resource}/see-more/short-video/`, { params })
}

const getShortRelated = (params) => {
  return Client.get(`${resource}/event/related-to/`, { params })
}

const userRepository = {
  getRandomShort,
  getShortRelated,
  getShortById
}
export default userRepository
